import { type EmailToggle } from '~entities/settings/email-settings/api/get-email-toggles';

import { EmailToggleCard } from './email-toggle-card';

interface EmailTogglesGridProps {
  toggles: Array<EmailToggle>;
  disabled?: boolean;
}

export const EmailTogglesGrid = ({
  toggles,
  disabled = false,
}: EmailTogglesGridProps) => {
  if (toggles.length === 0) {
    return <div className='py-8 text-center'>No email settings found</div>;
  }

  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
      {toggles
        .sort((a, b) => a.scenarioName.localeCompare(b.scenarioName))
        .map((toggle) => (
          <EmailToggleCard
            key={toggle.id}
            toggle={toggle}
            disabled={disabled}
          />
        ))}
    </div>
  );
};
